export default __webpack_public_path__ + "48c621d7a762d268d6d98e33f17c55f3.png";